import styled from 'styled-components';
import { Button } from '../Button';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Pages = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Page = styled(Button)`
  width: 32px;
  height: 32px;
  padding: 0;
  text-align: center;

  ${(props) => ({
    fontWeight: props.active ? 'bold' : 'normal',
  })}
`;
